import React from 'react';
import { HorizontalDivider } from '../components/dividers';
import { LoginModes } from '../../common/constants/login-modes';
import { keepFocus } from '../../common/services/keep-focus';
import { useTranslate } from '../context/api-context/translations/use-translate';
import { useApi } from '../context/api-context/use-api';
import ButtonGroup from '../components/button-group/button-group';
import styles from './login-required-empty-state.scss';
import TextExtended from '../components/text-extended/text-extended';
import { getIsMobile } from '../../common/store/base-params/base-params-selectors';
import { useConfiguration } from '../context/configuration-context/use-configuration';
const LoginRequiredEmptyState = () => {
    const t = useTranslate();
    const [isMobile, { biAttemptLoginSignup }] = useApi((state, actions) => [
        getIsMobile(state),
        actions,
    ]);
    const { resourceId } = useConfiguration();
    const requestLoginPromisified = useApi((_, action) => action.requestLoginPromisified);
    const requestLogin = (mode) => {
        biAttemptLoginSignup({ type: mode, resourceId });
        return requestLoginPromisified(mode);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HorizontalDivider, { className: styles.topDivider, type: "header" }),
        React.createElement("div", { className: styles.innerContainer },
            React.createElement(TextExtended, { className: styles.title, typography: "titleSmall" }, t('empty-state.login-required-title')),
            React.createElement(TextExtended, { className: styles.text }, t('empty-state.login-required-text')),
            React.createElement(ButtonGroup, { className: styles.buttons, primaryButtonProps: {
                    className: styles.button,
                    onClick: () => keepFocus(requestLogin)(LoginModes.login),
                    text: t('empty-state.login'),
                }, secondaryButtonProps: {
                    className: styles.button,
                    onClick: () => keepFocus(requestLogin)(LoginModes.signup),
                    text: t('empty-states.register'),
                }, layout: isMobile ? 'verticalReverse' : 'horizontalReverse' })),
        React.createElement(HorizontalDivider, { type: "header" })));
};
export default LoginRequiredEmptyState;
//# sourceMappingURL=login-required-empty-state.js.map